/***
 * @file:
 * @author: linkun.he
 * @Date: 2020-05-11 15:12:21
 */

import { Component, ElementRef, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { differenceInCalendarDays } from 'date-fns';

import { ControlValueAccessorService } from '../../control-value-accessor.service';
import monitor from '../../monitor';
// import { customInputControlValueAccessor } from './../../../utils/form.utils';
@Component({
  selector: 'dt-form-date-picker',
  templateUrl: './form-date-picker.component.html',
  styleUrls: ['./form-date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormDatePickerComponent),
      multi: true,
    },
  ],
})
export class FormDatePickerComponent extends ControlValueAccessorService {
  today = new Date().getTime();
  @Input() type = 'datePicker';
  @Input() prop = '';
  value: any = this.type === 'datePickerRange' ? [] : '';
  time: Date | null = this.value || null;
  @Input() disabled = false;
  @Input() placeholder = 'è¯·éæ©';
  @Input() itemClass = '';
  @Input() size = 'default';
  // æ ¼å¼åæ¶é´
  @Input() dateFormat;
  // éå¶çæ¶é´æ®µ [from, to]  å¯å¡«ï¼~ã'2020-05-11'ãæ¶é´æ³
  //    - ['~'ã'2020-05-01'] 5-1åä¸å¯é
  //    - ['2020-05-01'ã'~'] 5-1åä¸å¯é
  //    - ['2020-05-01'ã'2020-05-10'] (2020-05-01~2020-05-10)ä¹é´ä¸å¯é
  @Input() disabledRange;
  @Output() valueChange = new EventEmitter<any>();

  constructor(private el: ElementRef) {
    super();
  }
  writeValue(value) {
    if (!this.isFrist) {
      monitor.emit('formValueChange', this.prop);
    }
    if (Object.prototype.toString.call(value) === '[object Number]') {
      value = new Date(value);
    }
    this.value = value;
    this.updateChanges();
  }

  updateChange() {
    this.updateChanges();
    // éæ©å¨ä¸ºæ¶é´éæ©å¨ï¼éæ©æ¶åç§ï¼
    if (this.type === 'datePickerTime') {
      this.handleTimePicker();
      return;
    }

    // éæ©å¨ä¸ºæ¶é´èå´éæ©å¨
    if (this.type === 'datePickerRange') {
      this.handleDateRangePicker();
      return;
    }

    // å¶ä»éæ©å¨çå¤ç
    this.handleOtherPicker();
  }

  // ControlValueAccessorçæ¥å£ï¼ ç¶ç»ä»¶å¼æ´æ°
  // writeValue(value: any) {
  //   this.value = standardDate(value);
  // }

  // æ¥æéå¶
  disabledDate = (current: Date): boolean => {
    if (!this.disabledRange) {
      return;
    }
    const startTime = this.disabledRange[0];
    let endTime = this.disabledRange[1];

    if (this.type === 'datePickerYear' && endTime !== '~') {
      endTime = endTime * 1 + 1 + '';
    }

    if (this.type === 'datePickerMonth' && endTime !== '~') {
      endTime = endTime.substr(0, 5) + (new Date(endTime).getMonth() + 2);
    }
    // console.log(this.disabledRange, startTime, endTime);
    // a-bä¹é´
    if (startTime !== '~' && endTime !== '~') {
      return differenceInCalendarDays(current, startTime) >= 0 && differenceInCalendarDays(current, endTime) <= 0;
    }
    // aä¹å
    if (startTime === '~' && endTime !== '~') {
      return differenceInCalendarDays(current, endTime) <= 0;
    }
    // bä¹å
    if (startTime !== '~' && endTime === '~') {
      return differenceInCalendarDays(current, startTime) >= 0;
    }
  };

  // å¤çæ¶åç§éæ©å¨
  handleTimePicker() {
    this.valueChange.emit(this.value);
    // é¦æ¬¡éæ©æ¶ï¼å¶å¼ä¸ºnull
    // if (this.time) {
    //   this.onChangeCallback(getTimestamp(this.time));
    //   return;
    // }
    this.onChangeCallback(this.time);
  }

  // å¤çäºä»¶èå´éæ©å¨
  handleDateRangePicker() {
    this.valueChange.emit(this.value);
    const val = this.value;
    // val = val.map((item) => {
    //   return getTimestamp(item);
    // });
    this.onChangeCallback(val);
  }

  // å¤çå¶ä»çéæ©å¨
  handleOtherPicker() {
    this.valueChange.emit(this.value);
    // if (this.value) {
    //   this.onChangeCallback(getTimestamp(this.value));
    //   return;
    // }
    this.onChangeCallback(this.value);
  }
}
